import { render, staticRenderFns } from "./ScrollForMore.vue?vue&type=template&id=2f30038d&scoped=true&"
import script from "./ScrollForMore.vue?vue&type=script&lang=js&"
export * from "./ScrollForMore.vue?vue&type=script&lang=js&"
import style0 from "./ScrollForMore.vue?vue&type=style&index=0&id=2f30038d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f30038d",
  null
  
)

export default component.exports